import PropTypes from 'prop-types';
import useChatbotStore from '@stores/chatbotStore';

export const ChatbotTrendingTopics = ({ trendingTopics, setToggleTrendingTopics }) => {
    const sendMessage = useChatbotStore(state => state.sendMessage);
    const flattenedTopics = trendingTopics.flat().map(item => item.query);

    const handleTopicClick = topic => {
        sendMessage(topic);
    };

    return (
        <div className="bg-gray-100 px-2 py-4 rounded-lg flex gap-2 items-center text-xs flex-wrap transition-all duration-300">
            {flattenedTopics.map((topic, index) => (
                <div
                    key={index}
                    className="bg-white flex items-center justify-center px-2 py-1 rounded-xl cursor-pointer hover:bg-gray-200 font-semibold"
                    onClick={() => {
                        handleTopicClick(topic);
                        setToggleTrendingTopics(false);
                    }}
                >
                    {topic}
                </div>
            ))}
        </div>
    );
};

ChatbotTrendingTopics.propTypes = {
    trendingTopics: PropTypes.arrayOf(
        PropTypes.shape({
            query: PropTypes.string.isRequired,
        }),
    ).isRequired,
    setToggleTrendingTopics: PropTypes.func.isRequired,
};
